import { FC, memo } from 'react';

import { SalesFilterForm, ISalesFilterForm } from './SalesFilterForm';

export const SalesFilter: FC<ISalesFilterForm> = memo((props) => <SalesFilterForm {...props} />);
